import {Observable} from "rxjs"

export enum MouseButton {
    Left = 0,
    Middle = 1,
    Right = 2,
}

export type NavigationOptions = {panningButtons: MouseButton[]; scaleFactor: number; maxScale: number; minScale: number}

export type Navigation = {
    transform: {scale: number; matrix: DOMMatrix}
    transformChange: Observable<{scale: number; matrix: DOMMatrix}>
    unregister: () => void
}

export type Point = {x: number; y: number}

export type Coords = {
    x: number
    y: number
}

export type Gesture = {
    origin: Coords
    translation: Coords
    scale: number
    rotation?: number
}

export type GestureCallbacks = {
    onGestureStart?: (gesture: Gesture) => void
    onGestureChange?: (gesture: Gesture) => void
    onGestureEnd?: (gesture: Gesture) => void
}

export type NormalizedWheelEvent = {
    dx: number
    dy: number
}

export type TrackpadZoom = {unregister: () => void; wheelListener: (event: WheelEvent) => void}
